import { get, post } from '../../../helpers/api'
import { api } from '../api'
import {
  SET_EWALLET_INDIVIDUAL_REPORT_DATA,
  SET_EWALLET_POPUP_REPORT_DATA,
  SET_EWALLET_REPORT_DATA,
  SET_QUEUE_REQUEST_RESPONSE,
  SET_REPORT_LIST_DATA,
  SET_VISITOR_HISTORY_LIST_DATA,
} from '../../../store/types'

export const getReportListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.mailNotification, query).then(response => {
      const json = response.data
      commit(SET_REPORT_LIST_DATA, {
        list: json,
      })
      resolve(response.data)
    })
  })
}

export const getTaxInvoiceSummaryReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.taxInvoiceSummaryReport, query).then(response => {
      commit(SET_QUEUE_REQUEST_RESPONSE, response.data)
      resolve(response.data)
    })
  })
}

export const getTaxInvoiceByProductReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.taxInvoiceByProductReport, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getProductSalesReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.saleProductReport, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getCvAllocationReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.cvAllocationReport, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getCwWbDetailReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.cwWbDetailReport, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getEwalletReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.eWalletReports, query).then(response => {
      let json = response.data

      commit(SET_EWALLET_REPORT_DATA, { data: json.data, columns: json.column_names })
      resolve(response.data)
    })
  })
}

export const getEwalletPopupReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api[query.url], query).then(response => {
      let json = response.data

      commit(SET_EWALLET_POPUP_REPORT_DATA, { data: json.data, columns: json.column_names })
      resolve(response.data)
    })
  })
}

export const getEwalletReportDocumentsAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api[query.url], query).then(response => {
      resolve(response.data)
    })
  })
}

export const getEwalletIndividualReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.eWalletIndividualReport, query).then(response => {
      let json = response.data

      commit(SET_EWALLET_INDIVIDUAL_REPORT_DATA, { data: json.data, columns: json.column_names })
      resolve(response.data)
    })
  })
}

export const getEwalletIndividualReportDocumentsAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.eWalletIndividualReport, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getStockistCommissionReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.stockistCommissionReport, query).then(response => {
      resolve(response.data)
    })
  })
}

export const getTaiwanPurchaseReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.taiwanPurchaseReport, query).then(response => {
      commit(SET_QUEUE_REQUEST_RESPONSE, response.data)
      resolve(response.data)
    })
  })
}

export const getMemberBvSvInfoReportAction = ({ commit }, query) => {
  return new Promise(resolve => {
    get(api.memberBvSvInfoReport + '?' + query).then(response => {
      resolve(response.data)
    })
  })
}

export const getVisitorHistoryListAction = ({ commit }, query) => {
  return new Promise(resolve => {
    post(api.visitorHistoryList, query).then(response => {
      let json = response.data

      commit(SET_VISITOR_HISTORY_LIST_DATA, { list: json })
      resolve(response.data)
    })
  })
}

export const downloadVisitorHistoryListAction = ({ commit, dispatch }, query) => {
  return new Promise(resolve => {
    post(api.visitorHistoryDownload, query).then(response => {
      resolve(response.data)
    })
  })
}
